import Icon from '../components/Icon.vue'

Icon.register({
  'user-tag': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M630.6 364.9L540.3 274.7C528.3 262.7 512 256 495 256H415.7C398 256 383.7 270.3 383.7 288V367.2C383.7 384.2 390.4 400.4 402.4 412.4L492.7 502.6C505.2 515.1 525.5 515.1 538 502.6L630.5 410.1C643.1 397.6 643.1 377.4 630.6 364.9zM447.8 343.9C434.5 343.9 423.8 333.2 423.8 319.9S434.5 295.9 447.8 295.9 471.8 306.6 471.8 319.9C471.8 333.1 461.1 343.9 447.8 343.9zM224 255.9C294.7 255.9 352 198.6 352 127.9 352 57.3 294.7 0 224 0S96 57.3 96 128C96 198.6 153.3 255.9 224 255.9zM351.8 367.1V294C339.6 290.4 326.9 287.8 313.6 287.8H296.9C274.7 298 250 303.8 224 303.8S173.4 298 151.1 287.8H134.4C60.2 287.9 0 348.1 0 422.3V463.9C0 490.4 21.5 511.9 48 511.9H400C415.5 511.9 429.1 504.4 437.9 493L379.9 435C361.8 416.9 351.8 392.8 351.8 367.1z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/user-tag.js
// module id = DTeN
// module chunks = 144